import { render, staticRenderFns } from "./BlogCard.vue?vue&type=template&id=4055be6e&"
import script from "./BlogCard.vue?vue&type=script&lang=js&"
export * from "./BlogCard.vue?vue&type=script&lang=js&"
import style0 from "./BlogCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports